import { UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from '../styles.css';

interface IPromoProps {
  link: string;
  text: string;
  onClick(evt: React.MouseEvent<HTMLAnchorElement>): void;
}

export function Promo({ link, text, onClick }: IPromoProps) {
  return (
    <div className={styles['action_button']} data-testid="promo">
      <a href={link} target="_blank" onClick={onClick}>
        <UIHeading4 color="primary_100">{text}</UIHeading4>
      </a>
    </div>
  );
}
